import { i18n, inject, pr, React, ui } from "aaa";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { MessageScreen } from "../common/MessageScreen";
import { TPPStore } from "./TPPStore";
import { pushRoute } from "stores/RouterFunctions";
import { TPPRoutes } from "./TPPRoutes";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
    store: TPPStore;
}

@i18n.injectIntl
@inject("externalInterfaceStore", "authStore")
export class TPPSuccess extends React.Component<IProps & i18n.InjectedIntlProps, {}> {
    render() {
        return (
            <MessageScreen
                useWebVersion
                variant="success"
                icon={pr.IconMessageOk}
                message={ui.__("tpp.success.message")}
                buttonLabelId="common.close"
                onDismiss={() => this.props.externalInterfaceStore.raiseExitSuccess()}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/tpp/TPPSuccess.tsx